export default function setProvinceErrAction(provinceError) {
    return {
        type: 'SET_PROVINCE_ERR',
        payload: provinceError
    }
}